module.exports = __webpack_public_path__ + "img/image (11).b3b39d92.webp";